import { ButtonBase, Typography } from '@material-ui/core'

import { lang } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import { SiteKeys } from '../../types/sitekey'
import useStyles from './styles/SitekeysRow.styles'

interface SitekeysRowMobileProps {
  sitekeyData: SiteKeys
  hasAccessToEditSiteKey: boolean | undefined
}
const SitekeysRowMobile: React.FC<SitekeysRowMobileProps> = ({
  sitekeyData,
  hasAccessToEditSiteKey
}) => {
  const classes = useStyles()

  return (
    <ButtonBase
      className={classes.root}
      component={LocalizedLink}
      to={hasAccessToEditSiteKey ? `/sitekeys/${sitekeyData.Id}/edit` : ''}>
      <div>
        <Typography variant="body1">
          {lang === 'en'
            ? sitekeyData.EntityName
            : sitekeyData.EntityNameTranslatedList[0].value}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{sitekeyData.CORSURLs[0]}</Typography>
      </div>
    </ButtonBase>
  )
}
export default SitekeysRowMobile
